import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media, Text, Link, textStyle, ChevronDownIcon, useSmallerThan } from '@elseu/sdu-titan';
import React, { useContext, isValidElement } from 'react';
import styled, { css } from 'styled-components';
import { GradientOverlay } from '../../components/GradientOverlay/GradientOverlay.js';
import { InPageNavigationContext } from '../../components/Page/InPageNavigationContext.js';
import '../../components/Page/Page.js';
import { createSlug } from '../../utilities/createSlug/createSlug.js';
import { scrollToSection } from '../../utilities/scrollToSection/scrollToSection.js';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionNavigation = styled(Section)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n  "])), theme.designTokens.colors.secondary40);
});
var Content = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n  "])), media.greaterThan('s')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n    "], ["\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n    "]))), getSectionSpacing({
    theme: theme,
    yPadding: 4,
    xPadding: [4, 8, 12, 24]
  }));
});
var ScrollLabel = styled(Text)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "], ["\n    flex-shrink: 0;\n    padding-top: ", ";\n    padding-bottom: ", ";\n  "])), theme.spacing[2], theme.spacing[2]);
});
var LinksContainerWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n  "], ["\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n  "])), theme.spacing[2], theme.spacing[2], media.greaterThan('s')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme.spacing[6], theme.spacing[6]));
});
var LinksContainer = styled.ul(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    list-style: none;\n    padding: 0;\n    gap: ", ";\n    overflow: auto hidden;\n    white-space: nowrap;\n    width: 100%;\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "], ["\n    position: relative;\n    display: flex;\n    list-style: none;\n    padding: 0;\n    gap: ", ";\n    overflow: auto hidden;\n    white-space: nowrap;\n    width: 100%;\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])), theme.spacing[6]);
});
var StyledScrollLink = styled(Link)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n    color: ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n    }\n\n    &:last-child {\n      margin-right: 24px;\n    }\n  "], ["\n    ", "\n    color: ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n    }\n\n    &:last-child {\n      margin-right: 24px;\n    }\n  "])), textStyle('labelBold'), theme.designTokens.colors.primary80, theme.designTokens.colors.primary60);
});
var DropdownWrapper = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    position: relative;\n    margin-top: ", ";\n\n    ", "\n  "], ["\n    position: relative;\n    margin-top: ", ";\n\n    ", "\n  "])), theme.spacing[2], media.greaterThan('s')(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "]))));
});
var Dropdown = styled.select(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), textStyle('label'), function (_a) {
  var theme = _a.theme;
  return "\n    cursor: pointer;\n    display: block;\n    appearance: none;\n    width: 100%;\n    padding: ".concat(theme.spacing[3], " ").concat(theme.spacing[4], ";\n    border-radius: ").concat(theme.borderRadius[2], ";\n    border: 1px solid ").concat(theme.designTokens.colors.grey30, ";\n    padding-right: calc(").concat(theme.spacing[4], " + 20px);\n  ");
});
var StyledChevronDownIcon = styled(ChevronDownIcon)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  position: absolute;\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n"], ["\n  position: absolute;\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[4];
});
/**
 * SectionNavigation component displays a navigation menu for sections
 * @param props - SectionNavigationProps
 * @returns JSX.Element
 */
var SectionNavigation = function (_a) {
  var reference = _a.reference;
  var elements = useContext(InPageNavigationContext).elements;
  var labels = React.Children.toArray(elements).map(function (element) {
    var _a;
    return isValidElement(element) && ((_a = element.props) === null || _a === void 0 ? void 0 : _a.name);
  }).filter(Boolean);
  var isMobile = useSmallerThan('s');
  var handleDropdownChange = function (event) {
    var selectedSection = event.target.value;
    if (selectedSection) {
      scrollToSection(selectedSection);
    }
  };
  return jsx(StyledSectionNavigation, {
    reference: reference,
    children: jsxs(Content, {
      children: [jsx(ScrollLabel, {
        type: "label",
        children: "Scroll direct naar:"
      }), !isMobile && jsxs(LinksContainerWrapper, {
        children: [jsx(LinksContainer, {
          children: labels.map(function (label) {
            return jsx(StyledScrollLink, {
              onClick: function () {
                return scrollToSection(label);
              },
              children: label
            }, label);
          })
        }), jsx(GradientOverlay, {})]
      }), isMobile && jsxs(DropdownWrapper, {
        children: [jsxs(Dropdown, {
          onChange: handleDropdownChange,
          children: [jsx("option", {
            value: "",
            children: "Kies een optie"
          }), labels.map(function (label) {
            return jsx("option", {
              value: createSlug(label),
              children: label
            }, label);
          })]
        }), jsx(StyledChevronDownIcon, {})]
      })]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;

export { SectionNavigation, StyledSectionNavigation };
//# sourceMappingURL=SectionNavigation.js.map
